import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/layout'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/home')
        },
        {
          path: 'ev',
          name: 'ev',
          component: () => import('@/views/ev')
        },
        {
          path: 'salvageValue',
          name: 'salvageValue',
          component: () => import('@/views/salvageValue')
        },
        {
          path: 'secondHand',
          name: 'secondHand',
          component: () => import('@/views/secondHand')
        },
        {
          path: 'aboutus',
          name: 'aboutus',
          component: () => import('@/views/aboutus')
        },
        {
          path: 'rank',
          name: 'rank',
          component: () => import('@/views/rank/rank.vue')
        },
        {
          path: 'cooperation',
          name: 'cooperation',
          component: () => import('@/views/cooperation')
        },
        {
          path: 'applyFor',
          name: 'applyFor',
          component: () => import('@/views/applyFor')
        }
      ]
    },
    {
      path: '/article',
      name: 'article',
      component: () => import('@/views/article/article.vue')
    },
    {
      path: '/consulting',
      name: 'consulting',
      component: () => import('@/views/consulting/consulting.vue')
    },
    {
      path: '/addArticle',
      name: 'addArticle',
      component: () => import('@/views/addArticle/addArticle.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/error-page/404'),
      hidden: true
    },
    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 切换动态路由滚动到首位
    return { x: 0, y: 0 }
  }
})

export default router
